import React from 'react'
import {numberFormat} from '../../utils/Functions'
import {IIncomeDocument} from './IncomeDocumentDetailPage'

interface IDefaultPriceSummary {
  total: number
  vatTotal: number
  vatItemPriceTotal: number
  zeroVatItemPriceTotal: number
  noVatItemPriceTotal: number
  whTaxPrice: number
}

interface IAccountOrderDepositSummary {
  priceSummaryInfo: IDefaultPriceSummary
  depositDocuments: IIncomeDocument[]
}

const AccountOrderDepositSummary: React.FC<IAccountOrderDepositSummary> = (props) => {
  const { priceSummaryInfo, depositDocuments } = props

  return (
    <div className={'d-flex'}>
      <div className={'px-4'}>
        <div className={'d-flex align-items-center'}>
          <span>ใบรับเงินมัดจำ <strong className={'fs-4'}>{depositDocuments?.length}</strong> ใบ</span>
          <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
            {numberFormat(priceSummaryInfo.total)}
          </strong>
        </div>
        {/*<div>*/}
        {/*  <span>{`เอกสารหมายเลข : `}</span>*/}
        {/*  <strong>{selected?.code || '-'}</strong>*/}
        {/*</div>*/}
        {/*<div className={'d-flex align-items-center'}>*/}
        {/*  <span>เงินมัดจำ</span>*/}
        {/*  <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>*/}
        {/*    {numberFormat(selected?.totalAmount || 0)}*/}
        {/*  </strong>*/}
        {/*  <span>บาท</span>*/}
        {/*</div>*/}
      </div>
      <div className={'d-flex flex-column align-items-end px-4'}>
        <div className={'d-flex align-items-center'}>
          <span>เงินมัดจำไม่มีหรือยกเว้นภาษี</span>
          <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
            {numberFormat(priceSummaryInfo.noVatItemPriceTotal)}
          </strong>
          <span>บาท</span>
        </div>
        <div className={'d-flex align-items-center'}>
          <span>เงินมัดจำที่คำนวณภาษี 0%</span>
          <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
            {numberFormat(priceSummaryInfo.zeroVatItemPriceTotal)}
          </strong>
          <span>บาท</span>
        </div>
        <div className={'d-flex align-items-center'}>
          <span>เงินมัดจำที่คำนวณภาษี 7%</span>
          <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
            {numberFormat(priceSummaryInfo.vatItemPriceTotal)}
          </strong>
          <span>บาท</span>
        </div>
        <div className={'d-flex align-items-center'}>
          <span>ภาษีมูลค่าเพิ่ม 7%</span>
          <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
            {numberFormat(priceSummaryInfo.vatTotal)}
          </strong>
          <span>บาท</span>
        </div>
      </div>
    </div>
  )
}

export default AccountOrderDepositSummary
